import PayCommissionForm from './PayCommissionForm';

export default PayCommissionForm;
